<template>
  <div class="ace-result">
    <span class="ace-result__name" v-if="name"> {{ name }}</span>
    <span class="ace-result__value" v-if="value"> {{ value }}</span>
    <span class="ace-result__unit" v-if="unit"> {{ unit }}</span>
  </div>
</template>

<script>
export default {
  props: ['name', 'value', 'unit'],
};
</script>

<style scoped lang="scss">
.ace-result {
  border: 1px solid #707070;
  border-radius: 4px;

  padding: 30px 15px;

  display: flex;
  flex-direction: column;

  justify-content: space-between;

  &__name {
    font-size: 21px;
    font-weight: bold;
  }
  &__value {
    color: #00a84e;

    font-size: 110px;
    font-weight: bold;
    line-height: 1;
    @media screen and (min-width: 767px) {
      font-size: 80px;
    }
    @media screen and (min-width: 992px) {
      font-size: 110px;
    }
  }
  &__unit {
  }
}
</style>
